/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getNotification, readAllNotification } from '../services';
import { changeDataNotification } from '../store';
import PaginationComponent from '../organism/DataTable/CustomDataTablePagination';

const Notifications = () => {
  const dispatch = useDispatch();
  const { dataNotification, mode } = useSelector((state) => state.global);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);

  const navigate = useNavigate();

  const getNotificationList = async (page) => {
    try {
      const response = await getNotification(mode === 'designer' ? 2 : 1, page);
      if (response?.data && response?.meta) {
        setData(response.data);
        setTotal(response.meta.total);

        await readAllNotification();

        if (
          dataNotification &&
          dataNotification.meta &&
          dataNotification.meta.total > 0
        ) {
          let clone = { ...dataNotification };
          clone.meta.total = 0;

          dispatch(changeDataNotification(clone));
        }
      }
    } catch (e) {
      setData([]);
      setTotal(0);
    }
  };

  useEffect(() => {
    getNotificationList(0);
  }, []);

  const onChangePage = (page) => {
    setPage(page);
    getNotificationList(page);
  };

  const _navigateToDetail = (orderNo, id) => {
    if (mode === 'designer') {
      if (orderNo) {
        navigate(`/project/view/${orderNo}`);
      }
    } else {
      if (orderNo && id) {
        let slug = orderNo.replace(/\//g, '-') + '-' + id;
        navigate(`/orders/detail/${slug}/`);
      }
    }
  };

  const handleClickNotifItem = (item) => {
    _navigateToDetail(item.order_number, item.order_id);
  };

  return (
    <div className="container-fluid mb-4 px-0">
      <div className="fs-5 fw-bold mt-2 mb-4">Notifications</div>

      {data.length > 0 ? (
        <div>
          {data
            .slice(0, 10)
            .sort((a, b) => {
              return new Date(b.date) - new Date(a.date);
            })
            .map((item, idx) => {
              return (
                <div
                  key={item.id}
                  onClick={() => handleClickNotifItem(item)}
                  className={`${
                    item.is_read
                      ? 'bg-white border notif-item-white'
                      : 'bg-light-blue notif-item-lightblue'
                  } rounded-3 p-3 mb-3`}
                >
                  <div className="fw-bold">{item.title}</div>
                  <div className="fz-14 mt-2">{item.content}</div>
                  <div className="text-right fz-12">
                    [{idx + 1 + page * 10}]
                  </div>
                </div>
              );
            })}

          <PaginationComponent
            total={total}
            page={page}
            limit={10}
            startPage={0}
            totalCurrent={data.length}
            setPage={onChangePage}
          />
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-center p-3 mt-3">
          There is no new notification.
        </div>
      )}
    </div>
  );
};

export default Notifications;
